import { Component, OnInit, ChangeDetectorRef, Output, EventEmitter, ViewChild, Input, isDevMode, OnDestroy } from '@angular/core';
import { FirebaseService } from '../../service/firebase.service';
import { SharedService } from '../../services/shared.service';

import { NestedTreeControl, FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource, MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material/tree';

import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { BehaviorSubject, Observable, of as observableOf } from 'rxjs';
import { UtilsService } from '../../services/utils.service';
import { ModalMainComponent } from '../../modals/modal-main/modal-main.component';
import { MatDialog } from '@angular/material/dialog';
import { ListSelectionModalComponent } from '../../modals/list-selection-modal/list-selection-modal.component';
import { TranslationPipe } from '../pipes/translation.pipe';
import { environment } from '../../../environments/environment';
import { ModalTextComponent } from '../../modals/modal-text/modal-text.component';
import { ModalTextInputComponent } from '../../modals/modal-text-input/modal-text-input.component';

export class FileNode {
  id: string;
  children: FileNode[];
  name: string;
  path: string;
  displayName: string;
  type: any;
  authorized?: boolean;
}


export class FileFlatNode {
  constructor(
    public expandable: boolean,
    public name: string,
    public displayName: string,
    public level: number,
    public type: any,
    public id: string,
    public path: string,
    public authorized: boolean
  ) { }
}

@Component({
  selector: 'app-treefile',
  templateUrl: './treefile.component.html',
  styleUrls: ['./treefile.component.scss']
})
export class TreefileComponent implements OnInit, OnDestroy {


  // public treeControl = new NestedTreeControl<any>(node => node.children);
  // public dataSource = new MatTreeNestedDataSource<any>();// = new MatTreeNestedDataSource<FoodNode>();


  treeControl: FlatTreeControl<FileFlatNode>;
  treeFlattener: MatTreeFlattener<FileNode, FileFlatNode>;
  dataSource: any;


  treeDataSource: MatTreeFlatDataSource<FileNode, FileFlatNode>;;

  expandedNodeSet = new Set<string>();
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;
  activeNode;
  selectedFolderId: any;
  selectedFolderNode: any;
  @Output() selectedFolder = new EventEmitter<any>();
  @Output() contentData = new EventEmitter<any>();
  @Output() moduleIdOut = new EventEmitter<any>();
  @Output() uploadFiles = new EventEmitter<any>();
  @Output() importElementEvent = new EventEmitter<any>();

  @Input() latestUpdate;
  @Output() latestUpdateChange: EventEmitter<any> = new EventEmitter<any>();

  private moduleId: string = '';



  @ViewChild('uploadInput') uploadInput;

  /*TEMPORARY VAR*/
  folderNameTMP: string = "";



  //  hasChild = (_: number, node: any) => !!node.children && node.children.length > 0;

  isFolder = () => { return false; }
  transformer = (node: FileNode, level: number) => {


    let expand = false;
    if (node.children != undefined && node.children.length > 0)

      expand = true;


    // console.log(node)
    return new FileFlatNode(expand, node.name, node.displayName, level, node.type, node.id, node.path, node.authorized);

  }
  private _getLevel = (node: FileFlatNode) => node?.level;
  private _isExpandable = (node: FileFlatNode) => node.expandable;
  private _getChildren = (node: FileNode): Observable<FileNode[]> => observableOf(node.children);
  private defaultFolder: any;
  private dialogRef;
  public isAdmin: boolean = false;
  public isDev: boolean = false

  mediaModuleSnapshot: any;
  hasChild = (_: number, _nodeData: FileFlatNode) => {
    // console.log(_nodeData)
    return _nodeData.expandable
  };



  constructor(public _firebase: FirebaseService, public translation: TranslationPipe, public _shared: SharedService, private _ref: ChangeDetectorRef, private _utils: UtilsService, public dialog: MatDialog) {
    // console.log(this._shared.selectedDevice, this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name)


    this.isDev = isDevMode();
    console.log("DEV MODE:", isDevMode())

    if (environment.adminUserId.includes(this._firebase.getLocalUser().uid))
      this.isAdmin = true;
    console.log(this._firebase.getLocalUser());
    this.treeFlattener = new MatTreeFlattener(this.transformer, this._getLevel,
      this._isExpandable, this._getChildren);
    this.treeControl = new FlatTreeControl<FileFlatNode>(this._getLevel, this._isExpandable);
    this.treeDataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    // database.dataChange.subscribe(data => this.rebuildTreeForData(data));

    this.buildFileTree([], 0);
    // console.log(this._shared.selectedDevice.data.modules);
    if (this._shared.selectedDevice)
      this._firebase.getModuleSnapshot('media', this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name).then((d) => {


        console.log("TRIGGER MODULE SNAPSHOT MEDIA FOR FILETREE", d)
        this.mediaModuleSnapshot = this._firebase.mediaModuleSnapshot.subscribe((d) => {


          this.moduleId = d.id;

          this.moduleIdOut.emit(d.id)
          //  if (d.data.fileTree == undefined) {
          //  this._firebase.addMedia('folder', '.').then((e) => {
          //    this._firebase.updateConfigModule({ fileTree: [{ type: 'folder'/*, path: '.'*/, firestoreId: e.id, children: [] }] }, d.id)
          //    this.dataSource = JSON.parse(JSON.stringify(d.data.fileTree))

          //    this.rebuildTreeForData(d.data.fileTree)
          this.contentData.emit(d)
          //   })
          //  }
          //  else {
          this.dataSource = JSON.parse(JSON.stringify(d.data.fileTree))

          console.log("SNAPSHOT MEDIA", d.data.fileTree, this._shared.selectedDevice.data.group, this._shared.selectedDevice.data.name)
          this.rebuildTreeForData(d.data.fileTree)
          this.contentData.emit(d);
          //  }
        })
      })

  }

  ngOnDestroy() {
    try {
      this.mediaModuleSnapshot?.unsubscribe();

    }
    catch (err) {

    }
  }


  visibleNodes(): FileNode[] {
    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);
    const result = [];

    function addExpandedChildren(node: FileNode, expanded: Set<string>) {
      result.push(node);
      if (expanded.has(node.id)) {
        node.children.map(child => addExpandedChildren(child, expanded));
      }
    }
    this.treeDataSource.data.forEach(node => {

      addExpandedChildren(node, this.expandedNodeSet);
    });
    return result;
  }

  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event: CdkDragDrop<string[]>) {
    // console.log('origin/destination', event.previousIndex, event.currentIndex);

    // console.log(event)

    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) return;

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource));

    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<any>, id: string): Array<any> {
      let result, subResult;
      arr.forEach(item => {
        if (item.id === id) {
          result = arr;
        } else if (item.children) {
          subResult = findNodeSiblings(item.children, id);
          if (subResult) result = subResult;
        }
      });
      return result;
    }

    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.id);
    const siblingIndex = siblings.findIndex(n => n.id === node.id);
    const nodeToInsert: FileNode = siblings.splice(siblingIndex, 1)[0];

    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    if (nodeAtDest.id === nodeToInsert.id) return;

    // determine drop index relative to destination array
    let relativeIndex = event.currentIndex; // default if no parent
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find(n => nodeAtDest.id === n.id);
    const parent = this.getParentNode(nodeAtDestFlatNode);
    if (parent) {
      const parentIndex = visibleNodes.findIndex(n => n.id === parent.id) + 1;
      relativeIndex = event.currentIndex - parentIndex;


      //console.log("AS PARENT")
    }
    // else
    // console.log("THIS IS A TEST")
    // insert node
    const newSiblings = findNodeSiblings(changedData, nodeAtDest.id);
    if (!newSiblings) return;
    newSiblings.splice(relativeIndex, 0, nodeToInsert);


    console.log("REBUILD DATA AFTER DROP", changedData)
    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);
    this._firebase.updateConfigModule({ fileTree: changedData, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
      this.latestUpdate = d;
      this.latestUpdateChange.emit(d)
    })

  }

  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    this.dragging = true;
  }
  dragEnd() {
    this.dragging = false;
  }
  dragHover(node: FileFlatNode) {


    // console.log("drag HOVER")
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {

        this.treeControl.expand(node);
        // console.log("INSIDE ?")
      }, this.expandDelay);
    }
  }
  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }

  /**
   * The following methods are for persisting the tree expand state
   * after being rebuilt
   */




  removeFilesFromDataTree(tab) {
    for (let i = 0; i < tab.length; i++) {
      if (tab[i].type != 'folder' || tab[i].custom == 'clientFolder') {
        tab.splice(i, 1)
        i--;
      }
      else if (tab[i].children != undefined && tab[i].children.length > 0) {
        this.removeFilesFromDataTree(tab[i].children)
      }
    }
    console.log()
    /* tab.reduceRight((_, item, i) => {
 
       //console.log("CHECKED ITEM:", item)
 
       if (item.type != 'folder') {
         //console.log("REMOVE ITEM:", item)
         tab.splice(i, 1)
       }
       else if (item.children != undefined && item.children.length > 0) {
         this.removeFilesFromDataTree(item.children)
       }
     })
     */
    /* tab.forEach((item, index, object) => {
       if (item.type != 'folder') {
         object.splice(index, 1)
       }
       else if (item.children != undefined && item.children.length > 0) {
         this.removeFilesFromDataTree(item.children)
       }
     })*/
  }


  rebuildTreeForData(data: any) {
    let tmpData = JSON.parse(JSON.stringify(data));

    console.log(tmpData)
    this.removeFilesFromDataTree(tmpData)

    this.rememberExpandedTreeNodes(this.treeControl, this.expandedNodeSet);

    this.treeDataSource.data = tmpData;
    this.forgetMissingExpandedNodes(this.treeControl, this.expandedNodeSet);
    this.expandNodesById(this.treeControl.dataNodes, Array.from(this.expandedNodeSet));

    console.log(this.selectedFolderId)
    console.log("CHECK SUBUSER LOGIC", this._firebase.user.role == 'subuser', isDevMode())
    /* SUBUSER CUSTOM LOGIC*/
    //  alert(isDevMode())
    if (this._firebase.user.role == 'subuser' && this._firebase.user.assignedDevice && !this._firebase.user.enableAllContent && this._firebase.user.parentuid == '96oXRJRiaBNX5fWzodHlXlBrnUr2' /*(this._firebase.user.subuid == '96oXRJRiaBNX5fWzodHlXlBrnUr2' || isDevMode())*/) {
      //        alert("SET DEFAULT FOLDER TO SUBUSER")  
      let tmp = JSON.parse(JSON.stringify(this.treeDataSource.data))

      //console.log("NEED TO LOAD LAST FOLDER", this.treeDataSource.data.splice(-1)[0])
      console.log(this.selectedFolderNode)
      // setTimeout(() => {
      if (!this.selectedFolderNode)
        this.setSelectedFolder(tmp.splice(-1)[0])
      else
        this.setSelectedFolder(this.selectedFolderNode);


      this.treeDataSource.data = this.checkIfFolderAvailable(this.treeDataSource.data)
      console.log(this.checkIfFolderAvailable(this.treeDataSource.data));


      //      this._ref.detectChanges();
      //  }, 100)

    }
    else if (this.selectedFolderId != null) {

      this.setSelectedFolder(this.selectedFolderNode)
      console.log("SELECTED FOLDER", this.selectedFolderId, this.selectedFolderNode)
    }

    else {
      console.log("GO TO ROOT FOLDER")
      this.goToRootFolder();
    }
    // alert("TEST")

    if (this.selectedFolder == null && this.defaultFolder == null)
      this.goToRootFolder();
    this._ref.detectChanges();
  }

  checkIfFolderAvailable(arr) {

    let loopThrough = (tab, auth = null) => {
      tab.forEach(item => {
        console.log(item.id, this.defaultFolder.id, auth)
        if (auth)
          item.authorized = true;
        if (item.id == this.defaultFolder.id || auth == true) {
          item.authorized = true;
          // if (auth != null)
          loopThrough(item.children, true)
        }


      })

    }

    if (this.defaultFolder)
      loopThrough(arr);

    return arr;

  }

  buildFileTree(obj: { [key: string]: any }, level: number, parentId: string = '0'): FileNode[] {


    console.log("BUILD FILE TREE")
    return Object.keys(obj).reduce<FileNode[]>((accumulator, key, idx) => {
      const value = obj[key];
      const node = new FileNode();
      node.name = key;



      console.log(node)
      /**
       * Make sure your node has an id so we can properly rearrange the tree during drag'n'drop.
       * By passing parentId to buildFileTree, it constructs a path of indexes which make
       * it possible find the exact sub-array that the node was grabbed from when dropped.
       */
      node.id = `${parentId}/${idx}`;

      if (value != null) {
        if (typeof value === 'object') {
          node.children = this.buildFileTree(value, level + 1, node.id);
        } else {
          node.type = value;
        }
      }

      return accumulator.concat(node);
    }, []);
  }



  tmp(elem) {
    return JSON.stringify(elem);
  }


  private rememberExpandedTreeNodes(
    treeControl: FlatTreeControl<FileFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      treeControl.dataNodes.forEach((node) => {
        if (treeControl.isExpandable(node) && treeControl.isExpanded(node)) {
          // capture latest expanded state
          expandedNodeSet.add(node.id);
        }
      });
    }
  }

  private forgetMissingExpandedNodes(
    treeControl: FlatTreeControl<FileFlatNode>,
    expandedNodeSet: Set<string>
  ) {
    if (treeControl.dataNodes) {
      expandedNodeSet.forEach((nodeId) => {
        // maintain expanded node state
        if (!treeControl.dataNodes.find((n) => n.id === nodeId)) {
          // if the tree doesn't have the previous node, remove it from the expanded list
          expandedNodeSet.delete(nodeId);
        }
      });
    }
  }

  private expandNodesById(flatNodes: FileFlatNode[], ids: string[]) {
    if (!flatNodes || flatNodes.length === 0) return;
    const idSet = new Set(ids);
    return flatNodes.forEach((node) => {
      if (idSet.has(node.id)) {
        this.treeControl.expand(node);
        let parent = this.getParentNode(node);
        while (parent) {
          this.treeControl.expand(parent);
          parent = this.getParentNode(parent);
        }
      }
    });
  }

  private getParentNode(node: FileFlatNode): FileFlatNode | null {
    const currentLevel = node.level;
    if (currentLevel < 1) {
      return null;
    }
    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;
    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];
      if (currentNode.level < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  createNewFolder(name) {
    //  console.log(this.dataSource.data)

    let _data = this.dataSource

    //  console.log(_data);

    /* if(_data.length > 0)
       _data[0].children.push({ type: 'folder', path: '.', name: name, children: [], id: 'TESTID' })
     else*/


    this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {
      if (d) {
        this._firebase.addMedia('folder', name).then((d) => {
          _data.push({ type: 'folder', path: '.', name: name, children: [], id: d.id })
          this._firebase.updateConfigModule({ fileTree: _data, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
            this.latestUpdate = d;
            this.latestUpdateChange.emit(d)
          })

        })
      }
    })




    // this.dataSource.data.push()



  }

  checkTimeStampBefore(type, param) {
    console.log(this.latestUpdate)
    this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {

      //console.log(d);
      if (d) {


        switch (type) {
          case 'addFolder':
            this.addFolder(param);
            break;
          case 'import':
            this.importElement(param);
            break;
          case 'startUpload':
            this.startFileUpload();
            break;
          case 'rename':
            this.renameFolder(param)
            break;
          case 'move':
            this.moveTo(param)
            break;
          case 'delete':
            this.deleteElement(param);
            break;
          case 'addConfig':
            this.addClientConfig()
        }

      }
    })
  }

  addClientConfig() {
    this.dialogRef = this.dialog.open(ModalTextInputComponent, {
      width: '30vw',
      height: '30vh',
      data: {
        title: "Veuillez entrer l'email de la configuration"
      }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      console.log(result)

      if (result) {
        this._firebase.checkIfUserExist(result).then(d => {

          if (d.length > 0) {
            console.log(this.selectedFolderId)
            this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {
              if (d) {
                let id = null
                if (this.selectedFolderId != null && this.selectedFolderId != undefined)
                  id = this.selectedFolder



                this._firebase.getUserDataByEmail(result).then(d => {
                  //  console.log(d.data.displayName, d.id)
                  this.addElementToChildren(id, d.data.displayName, 'clientFolder', { uid: d.id }).then((data) => {
                    this._firebase.updateConfigModule({ fileTree: data, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                      this.latestUpdate = d;
                      this.latestUpdateChange.emit(d)
                    })
                    this.importElementEvent.emit();
                  })
                })

                /*   
                   })*/
              }
            })


          }
        })
      }


    })

  }

  addFolder(item = null) {
    // console.log(item)


    var _data = {
      type: 'text',
      title: this.translation.transform('enterFolderName'),
      buttonLabel: this.translation.transform('validate'),
      buttonColor: 'accent',
    };


    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '50vh',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.currentValue.length > 0)


          if (item != undefined) {
            this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {
              if (d) {
                this.addElementToChildren(item.id, result.currentValue, 'folder').then((data) => {
                  this._firebase.updateConfigModule({ fileTree: data, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                    this.latestUpdate = d;
                    this.latestUpdateChange.emit(d)
                  })
                  this.importElementEvent.emit();
                })
              }
            })

          }

          else if (this.selectedFolderId != undefined) {
            this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {
              if (d) {
                this.addElementToChildren(this.selectedFolderId, result.currentValue, 'folder').then((data) => {
                  this._firebase.updateConfigModule({ fileTree: data, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                    this.latestUpdate = d;
                    this.latestUpdateChange.emit(d)
                  })
                  this.importElementEvent.emit();
                })
              }
            })
          }
          else {
            this._firebase.checkModifTimestamp(this.latestUpdate, this.moduleId).then(d => {
              if (d) {
                this.addElementToChildren(null, result.currentValue, 'folder').then((data) => {
                  this._firebase.updateConfigModule({ fileTree: data, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
                    this.latestUpdate = d;
                    this.latestUpdateChange.emit(d)
                  })
                  this.importElementEvent.emit();
                })
              }
            })
          }
      }

    });


  }

  moveTo(id) {
    /*  let elems = this._utils.getAllNestedArrayElement(this.dataSource, id);
  
      //console.log("MOVE TO:", elems)*/


    this.dialogRef = this.dialog.open(ListSelectionModalComponent, {

      height: '50vh',
      data: { data: this.dataSource, id: id, type: "folder", buttonLabel: 'OK' }
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //    console.log(result);

        if (result.currentValue[0].root) {
          let elem = this._utils.getFolderFromId(this.dataSource, id)

          this._utils.deleteElementFromNestedArray(this.dataSource, id);

          this.dataSource.push(elem);

        }
        else {
          let targetId = result.currentValue[0].id;

          this._utils.moveElement(this.dataSource, targetId, id)
        }
        this._firebase.updateConfigModule({ fileTree: this.dataSource, latestUpdate: this.latestUpdate }, this.moduleId).then(d => {
          this.latestUpdate = d;
          this.latestUpdateChange.emit(d)
        })

        /*
 
         //console.log('DATASOURCES:', this.dataSource)
        */
      }
      /*if (result) {
        //console.log(result)
        result.currentValue.forEach((item, index) => {
          if (type == 'web') {
            this.addElementToChildren(this.selectedFolderId, item.name, 'web', { thumbnailUrl: item.thumbnailUrl, url: item.url }).then((d) => {
              if (index == (result.currentValue.length - 1))
                this._firebase.updateConfigModule({ fileTree: d }, this.moduleId)
            })
          }
          else if (type == 'quiz') {
            this.addElementToChildren(this.selectedFolderId, item.data.name, 'quiz', { idModule: item.data.idModule, idQuiz: item.id }).then((d) => {
              if (index == (result.currentValue.length - 1))
                this._firebase.updateConfigModule({ fileTree: d }, this.moduleId)
            })
          }

        })
      }*/
    });
  }


  goToRootFolder() {

    console.log("GO TO ROOT FOLDER", this._firebase.user.role, isDevMode(), this._firebase.user.uid, (this._firebase.user.uid != '96oXRJRiaBNX5fWzodHlXlBrnUr2' && !isDevMode()), (this._firebase.user.role != 'subuser') || (this._firebase.user.uid != '96oXRJRiaBNX5fWzodHlXlBrnUr2' && !isDevMode()))
    /* SUBUSER CUSTOM LOGIC */



    console.log(this.defaultFolder, this.selectedFolderId)
    if (/*(this._firebase.user.role != 'subuser') || (this._firebase.user.uid != '96oXRJRiaBNX5fWzodHlXlBrnUr2' && !isDevMode())*/!this._firebase.user.assignedDevice || this._firebase.user.enableAllContent) {

      console.log("EMIT ROOT FOLDER")
      this.activeNode = null;
      this.selectedFolderId = null;
      this.selectedFolder.emit({ node: null, contentData: null })
    }
    else if (this._firebase.user.assignedDevice && this._firebase.user.parentuid != '96oXRJRiaBNX5fWzodHlXlBrnUr2') {
      this.activeNode = null;
      this.selectedFolderId = null;
      this.selectedFolder.emit({ node: null, contentData: null })
    }
    else if (this._firebase.user.assignedDevice) {
      this.setSelectedFolder(this.defaultFolder)

    }



  }

  addElementToChildren(id, name, type, moduleData: any = {}) {
    let tmp = this.dataSource;



    //console.log("ADD ELEMENT TO CHILDREN", id, name, type)
    return new Promise<any>((resolve, reject) => {



      /** CHECK IF ROOT OR CHILDREN **/
      if (id == null) {


        if (type == 'folder')
          this._firebase.addMedia('folder', name).then((d) => {
            tmp.push({ type: 'folder', path: `.`, name: name, displayName: name, children: [], id: d.id })
            resolve(this.dataSource)

          })
        else if (type == 'clientFolder') {
          this._firebase.addMedia('folder', name).then((d) => {
            tmp.push({ type: 'folder', custom: 'clientFolder', path: `.`, name: name, displayName: name, id: d.id, clientId: moduleData.uid })
            resolve(this.dataSource)

          })
        }
        else if (type == 'web') {


          //console.log("MODULE DATA WEB", moduleData)


          //    console.log(moduleData)
          this._firebase.addMedia('web', name, { thumbnail: moduleData.thumbnailUrl, url: moduleData.url, id: moduleData.id, filename: moduleData.filename }).then((d) => {




            tmp.push({ type: 'web', name: name, thumbnailName: moduleData.filename, id: d.id, thumbnail: moduleData.thumbnailUrl })
            resolve(this.dataSource)
          })
        }
        else if (type == 'quiz') {
          this._firebase.addMedia('quiz', name, moduleData).then((d) => {
            tmp.push({ type: 'quiz', name: name, id: d.id, idQuiz: moduleData.idQuiz })
            resolve(this.dataSource)
          })
        }
        else if (type == 'lottery') {

          //console.log("ADD LOTTERY TO ROOT")
          this._firebase.addMedia('lottery', name, moduleData).then((d) => {

            //console.log(d)


            tmp.push({ type: 'lottery', name: name, id: d.id })
            resolve(this.dataSource)
          }).catch(err => {
            console.log(err);
          })
        }


      }

      let tmpFunc = (data) => {
        data.forEach((item) => {
          if (item.id == id) {
            if (type == 'folder') {
              this._firebase.addMedia('folder', name).then((d) => {
                item.children.push({ type: 'folder', path: `${item.path}/${item.name}`, name: name, displayName: name, children: [], id: d.id })
                resolve(this.dataSource)

              })
            }
            else if (type == 'clientFolder') {
              this._firebase.addMedia('folder', name).then((d) => {
                tmp.push({ type: 'folder', custom: 'clientFolder', path: `${item.path}/${item.name}`, name: name, displayName: name, id: d.id })
                resolve(this.dataSource)

              })
            }
            else if (type == 'web') {



              this._firebase.addMedia('web', name, { thumbnail: moduleData.thumbnailUrl, url: moduleData.url, id: moduleData.id, filename: moduleData.filename }).then((d) => {
                item.children.push({ type: 'web', name: name, thumbnailName: `${name}.jpg`, id: d.id, thumbnail: moduleData.thumbnailUrl })
                resolve(this.dataSource)
              })
            }

            else if (type == 'quiz') {
              this._firebase.addMedia('quiz', name, moduleData).then((d) => {
                //   console.log("ADDED QUIZ IN MEDIA")
                item.children.push({ type: 'quiz', name: name, id: d.id, idQuiz: moduleData.idQuiz })
                resolve(this.dataSource)
              })
            }
            else if (type == 'lottery') {
              this._firebase.addMedia('lottery', name, moduleData).then((d) => {
                tmp.push({ type: 'lottery', name: name, id: d.id })
                resolve(this.dataSource)
              })
            }
          }
          else if (item.children != undefined && item.children.length > 0) {
            tmpFunc(item.children);
          }
        })
      }
      tmpFunc(tmp);
    })
  }


  deleteElement(id) {
    let deepClone = JSON.parse(JSON.stringify(this.dataSource))

    this._utils.getElementFromNestedArray(deepClone, id).then((data) => {
      deepClone = JSON.parse(JSON.stringify(this.dataSource))
      this._utils.getAllChildrenOfElement(deepClone, id).then((d) => {
        d.forEach((item) => {

          if (item.type == 'file') {
            this._firebase.getDocDataAndDeleteFile(item.id)
          }
          else
            this._firebase.deleteMedia(item.id, this._shared.selectedDevice);
        })
        this._firebase.deleteMedia(id, this._shared.selectedDevice);
        this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate, fileTree: data }, this.moduleId).then(d => {
          this.latestUpdate = d;
          this.latestUpdateChange.emit(d)
        })
      })



    })

    // this._firebase.deleteMedia(id);
  }



  setSelectedFolder(node) {
    console.log("SELECT FOLDER", node)
    this.selectedFolderId = node.id;

    if (!this.selectedFolderNode) {
      this.defaultFolder = node;
      this._shared.defaultFolder = node
    }

    this.selectedFolderNode = node;



    console.log("EMIT SELECTED FOLDER", node, this.dataSource, this.treeDataSource)
    this.selectedFolder.emit({ node: node, contentData: this.dataSource })
  }

  addElementToRoot(name, type, moduleData: any = {}) {



    return new Promise((resolve, reject) => {
      let tmp = this.dataSource

      // console.log("MODULE DATA:", moduleData)
      if (type == 'web')
        this._firebase.addMedia('web', name, { thumbnail: moduleData.thumbnailUrl, url: moduleData.url, id: moduleData.id }).then((d) => {

          tmp.push({ type: 'web', name: name, id: d.id })
          resolve(this.dataSource)
        })
      else if (type == 'quiz') {

      }
    })

  }


  importElement(type) {

    var _data = {
      type: type,
      title: this.translation.transform('chooseImportElement'),
      buttonLabel: this.translation.transform('validate'),
      buttonColor: 'accent',
    };
    //console.log("IMPORT TYPE", type)
    //  if (type == 'lottery') {

    //  }
    //  else if (type != 'lottery') {


    this.dialogRef = this.dialog.open(ListSelectionModalComponent, {

      height: '50vh',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {
        //   console.log(result)
        result.currentValue.forEach((item, index) => {
          if (type == 'web') {
            //    console.log("ITEM IMPORT WEB", item)
            if (item.thumbnailUrl == undefined)
              item.thumbnailUrl = null;
            if (item.filename == undefined)
              item.filename = null;


            this.addElementToChildren(this.selectedFolderId, item.name, 'web', { thumbnailUrl: item.thumbnailUrl, url: item.url, id: item.id, filename: item.filename }).then((d) => {
              if (index == (result.currentValue.length - 1)) {
                this._firebase.updateConfigModule({ fileTree: d, latestUpdate: this.latestUpdate }, this.moduleId).then(f => {
                  this.latestUpdate = f;
                  this.latestUpdateChange.emit(f)
                })
                //      console.log("LOG IMPORT WEB:", item, d)
                this.importElementEvent.emit()
              }

              //  this.importElementEvent.emit({id: })
            })
          }
          else if (type == 'quiz') {
            this.addElementToChildren(this.selectedFolderId, item.data.name, 'quiz', { idModule: item.data.idModule, idQuiz: item.id }).then((d) => {
              if (index == (result.currentValue.length - 1)) {
                this._firebase.updateConfigModule({ fileTree: d, latestUpdate: this.latestUpdate }, this.moduleId).then(f => {
                  this.latestUpdate = f;
                  this.latestUpdateChange.emit(f)
                })
                this.importElementEvent.emit()
              }

            })
          }
          else if (type == 'lottery') {
            //console.log(item)

            this.addElementToChildren(this.selectedFolderId, item.name, 'lottery', { thumbnail: { name: '', url: '' } }).then(d => {
              this._firebase.updateConfigModule({ fileTree: d, latestUpdate: this.latestUpdate }, this.moduleId).then(f => {
                this.latestUpdate = f;
                this.latestUpdateChange.emit(f)
              })
              this.importElementEvent.emit()
            })
            /*   this.addElementToChildren(this.selectedFolderId, "Loterie", 'lottery', { thumbnail: { name: '', url: '' }, }).then((d) => {
                 //  if (index == (result.currentValue.length - 1)) {
   
                 console.log(d)
                 this._firebase.updateConfigModule({ fileTree: d, latestUpdate: this.latestUpdate }, this.moduleId).then(f => {
                   this.latestUpdate = f;
                   this.latestUpdateChange.emit(f)
                 })
                 //      console.log("LOG IMPORT WEB:", item, d)
                 this.importElementEvent.emit()
                 //  }
   
                 //  this.importElementEvent.emit({id: })
               })*/
          }

        })
      }
    });
    //  }
  }


  renameFolder(node) {


    //console.log(node.displayName)

    var _data = {
      type: 'text',
      title: this.translation.transform('newFolderName'),
      buttonLabel: this.translation.transform('validate'),
      currentValue: node.displayName,
      buttonColor: 'accent',
    };


    this.dialogRef = this.dialog.open(ModalMainComponent, {

      height: '50vh',
      data: _data
    })

    this.dialogRef.afterClosed().subscribe(result => {
      if (result) {

        // console.log(result)
        /*if (result.currentValue.length > 0)


          if (item != undefined)
            this.addElementToChildren(item.id, result.currentValue, 'folder').then((data) => {
              this._firebase.updateConfigModule({ fileTree: data }, this.moduleId)
            })
          else {
            this.addElementToChildren(null, result.currentValue, 'folder').then((data) => {
              this._firebase.updateConfigModule({ fileTree: data }, this.moduleId)
            })
          }*/


        this._utils.renameNode(result.currentValue, node.id, this.dataSource)

        this._firebase.updateMediaName(node.id, result.currentValue, node).then(() => {
          this._firebase.updateConfigModule({ latestUpdate: this.latestUpdate, fileTree: this.dataSource }, this.moduleId).then(f => {
            this.latestUpdate = f;
            this.latestUpdateChange.emit(f)
          })
        })
      }

    });



    // console.log(this.dataSource)
    /*.then((d) => {

    })*/

    //this._firebase.updateMediaName(node.id, node.name)

  }

  startFileUpload() {
    this.uploadInput.nativeElement.click();

  }

  emitUpload(e) {
    this.uploadFiles.emit(e);

    this.uploadInput.nativeElement.value = '';
  }

  ngOnInit() {
    console.log("CURRENT USER", this._firebase.user)



  }


  editFolder($event, i) {
    $event.preventDefault();
    //console.log('right click 👏');

  }

}
